module.exports = __webpack_public_path__ + "static/media/icon-piece-5mmk-02.dce9c646.png";